<template>
  <Checkbox
    v-model:checked="TKDVerificationStatusModel.isVerificationNotPossible"
    label="Verifizierung nicht möglich"
    :test-id="testIdLabels.noVerification"
    @change="$emit('change', $event.target.checked)"
  />
  <div v-if="TKDVerificationStatusModel.isVerificationNotPossible" class="">
    <BaseDropdown
      v-model:selection="TKDVerificationStatusModel.reason"
      label="Grund auswählen"
      :options-list="noVerificationPossibleReasonList"
      :test-id="testIdLabels.reason"
    />

    <BaseTextarea
      v-if="TKDVerificationStatusModel.reason === 'OTHER'"
      v-model:input-text="TKDVerificationStatusModel.note"
      label="Bemerkung"
      :test-id="testIdLabels.note"
    />
  </div>
</template>

<script setup lang="ts">
import { noVerificationPossibleReasonList } from '@/enums/device';
import Checkbox from '@/components/UI/Checkbox/Checkbox.vue';
import BaseDropdown from '@/components/UI/Dropdown/BaseDropdown.vue';
import BaseTextarea from '@/components/UI/Note/BaseTextarea.vue';
import { TKDVerificationStatus } from '@/models/installationPoint/DeviceService';
import { computed } from 'vue';

const TKDVerificationStatusModel = defineModel<TKDVerificationStatus>(
  'tkdVerificationStatus'
);

const verificationType = defineModel<string>('verificationType');

const emit = defineEmits<{ (e: 'change', value: boolean): void }>();

const testIdLabels = computed(() => {
  if (verificationType.value === 'battery') {
    return {
      noVerification: 'no-battery-verification',
      reason: 'battery-verification-reason',
      note: 'battery-verification-note',
    };
  } else if (verificationType.value === 'device') {
    return {
      noVerification: 'no-device-verification',
      reason: 'device-verification-reason',
      note: 'device-verification-note',
    };
  }
  return '';
});
</script>
